import { GoogleAdapter } from './google-adapter.esm.js';
import { MapboxAdapter } from './mapbox-adapter.esm.js';
var thirdPartyAdapterRegister = {
  google: GoogleAdapter,
  mapbox: MapboxAdapter
};
var ThirdPartyAdapterFactory = /** @class */function () {
  function ThirdPartyAdapterFactory() {}
  ThirdPartyAdapterFactory.getInstance = function (k, locale, apiKey, version) {
    return thirdPartyAdapterRegister[k].getInstance(locale, apiKey, version);
  };
  ThirdPartyAdapterFactory.filterThirdPartyAdapterFromEssConfig = function (configFeaturesList) {
    return configFeaturesList.filter(function (v) {
      return v in thirdPartyAdapterRegister;
    });
  };
  return ThirdPartyAdapterFactory;
}();
export { ThirdPartyAdapterFactory };